import React from "react";
import HubMedLinkingPanel from "@/components/admin/hubmed/HubMedLinkingPanel";

const HubMedLinkingPage = () => (
  <div className="max-w-5xl mx-auto p-2 sm:p-4 space-y-6">
    <div>
      <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
        HubMed linking
      </h1>
    </div>

    <section className="rounded-2xl border border-slate-200/80 bg-white shadow-sm p-6">
      <HubMedLinkingPanel />
    </section>
  </div>
);

export default HubMedLinkingPage;
